import React from 'react';
import T from 'prop-types';
import { withNamespaces } from 'react-i18next';
import './styles.scss';

const FooterCopyright = ({ note, t }) => (
  <div className="footer-copyright">
    <div className="reset-padding copyright-content">
      <span>{t('components.Footer.Copyright.coppyrightText', { year: new Date().getFullYear() })}</span>
      {note && (
        <p className="footer-copyright__note">{note}</p>
      )}
    </div>
  </div>
);

FooterCopyright.propTypes = {
  note: T.string.isRequired,
};

export default withNamespaces('core')(FooterCopyright);



// WEBPACK FOOTER //
// ../src/components/Footer/Copyright/index.jsx